export function subscriptionReducer(state = null,{
    type,
    payload
}){
    switch(type){
        case "GET_SUBSCRIPTIONS":
            return payload;
        default:
            return state;
    }
}